import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login';
import Home from '@/views/home.vue';
import ProjectList from '@/views/project/list/index.vue';
import Projectfeature from '@/views/project-feature.vue';
import AddProject from '@/views/add-project.vue';
import AddPage from '@/views/add-page.vue';
import FeatureDetail from '@/views/feature-detail.vue';
import ComponentList from '@/views/component/list/index.vue';
import AllComponent from '@/views/all-component/index.vue';
import AllPage from '@/views/all-page/index.vue';
import ComponentDetails from '@/views/component/details/index.vue';
import EditPage from '@/views/edit-page/index.vue'
import ComponentUpload from '@/views/component/upload/index.vue'
import demo from '@/views/demo.vue'
import demo1 from '@/views/demo1.vue'
import HmBgCardView from '@/views/component/hm-bg-card/index.vue'
import HmGridView from '@/views/component/hm-grid/index.vue'
import HmTabsView from '@/views/component/hm-tabs/index.vue'
import HmModalView from '@/views/component/hm-modal/index.vue'
import Product from '@/views/product/index.vue'
import Buy from '@/views/component/buy/index'
import WeChatPay from '@/views/component/buy/WeChatPay/index'
import UserMessage from '@/views/user-message/index'
import TeamPage from '@/views/team-page/index'
import CompanyPage from '@/views/company-page/index'
import PaySuccess from '@/views/pay-success/index'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/hm-bg-card',
      name: 'hm-bg-card',
      component: HmBgCardView,
      meta: {                    
        requireAuth: false
      }
    },
    {
      path: '/hm-grid',
      name: 'hm-grid',
      component: HmGridView,
      meta: {                     
        requireAuth: false
      }
    },
    {
      path: '/hm-tabs',
      name: 'hm-tabs',
      component: HmTabsView,
      meta: {                     
        requireAuth: false
      }
    },
    {
      path: '/hm-modal',
      name: 'hm-modal',
      component: HmModalView,
      meta: {                     
        requireAuth: false
      }
    },
    {
      path: '/demo',
      name: 'demo',
      component: demo,
      
    },
    {
      path: '/demo1',
      name: 'demo1',
      component: demo1,
      
    },
    {
      path: '/',
      redirect: '/project/list',
      // meta: {                      //加一个自定义obj
      //   requireAuth: true      //这个参数 true 代表需要登录才能进入A
      // }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/component/list',
      name: '组件列表页',
      component: ComponentList,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
    },
    {
      path: '/component/details',
      name: '组件详情页',
      component: ComponentDetails,
      
    },
    {
      path: '/component/upload',
      name: '组件上传页',
      component: ComponentUpload,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
    },
    {
      path: '/project/list',
      name: '项目列表页',
      component: ProjectList,
      // meta: {                      //加一个自定义obj
      //   requireAuth: true      //这个参数 true 代表需要登录才能进入A
      // }
    },
    {
      path: '/all-component',
      name: '所有组件页',
      component: AllComponent,
      
    },
    {
      path: '/all-page',
      name: '所有页面',
      component: AllPage,
      
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      
    },
    {
      path: '/project-feature',
      name: 'project-feature',
      component: Projectfeature,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
    },
    {
      path: '/add-project',
      name: 'add-project',
      component: AddProject,
      
    },
    {
      path: '/add-page',
      name: '增加页面',
      component: AddPage,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
    },
    {
      path: '/feature-detail',
      name: 'feature-detail',
      component: FeatureDetail,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
    },
    {
      path: '/edit-page',
      name: 'edit-page',
      component: EditPage,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
    },
    {
      path: '/product/index',
      name: 'product',
      component: Product,
     
    },
    {
      path: '/buy/index',
      name: 'Buy',
      component: Buy,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
     
    },
    {
      path: '/WeChat-pay/index',
      name: 'WeChat-pay',
      component: WeChatPay,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
     
    },
    {
      path: '/user-message/index',
      name: 'user-message',
      component: UserMessage,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
     
    },
    {
      path: '/team-page/index',
      name: 'team-page',
      component: TeamPage,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
     
    },
    {
      path: '/company-page/index',
      name: 'company-page',
      component: CompanyPage,
        meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
     
    },
    {
      path:'/pay-success/index',
      name: 'pay-success',
      component: PaySuccess,
      meta: {                      //加一个自定义obj
        requireAuth: true      //这个参数 true 代表需要登录才能进入A
      }
    }
  ]
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};